import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { LoginView } from './views/LoginView'
import DashboardAutoView from './views/DashboardAutoView'
import { AdminView } from './views/AdminView'
import { MaquinasView } from './views/MaquinasView'
import ReportesListAutoView from './views/ReportesListAutoView'
import AnalisisView from './views/AnalisisView'
import InformeAvanceAutoView from './views/InformeAvanceAutoView'
import { CrearReporteAutoView, EditarReporteAutoView, ReporteDetalleAutoView } from './views/reportes'
import { OperadoresView, FaenasView, CalificadoresView, PrediosView, RodalesView, InsumosView, ProveedoresView, VehiculosView, TarjetasView, EmisoresView, ItemsChequeoView, EmpresasAdminView, AdminUsuariosMaquinasView, AdminUsuariosOperadoresView, ConfiguracionEmpresaView } from './views/admin'
import { GestionAutoView, OperacionView, ConsumosView } from './views/gestion'
import ControlCombustibleView from './views/ControlCombustibleView'
import OrdenesCargaCombustibleAutoView from './views/ordenesCarga/OrdenesCargaCombustibleAutoView'
import SolicitarCargaMovilView from './views/ordenesCarga/SolicitarCargaMovilView'
import CargarOrdenMovilView from './views/ordenesCarga/CargarOrdenMovilView'
import { PrivateRoute } from './components/auth/PrivateRoute'
import { Layout } from './components/layout'
import { EmpresasProvider } from './context/EmpresasContext'
import { AuthProvider } from './context/AuthContext'

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
      {/* Ruta pública - Login */}
      <Route path="/login" element={<LoginView />} />
      
      {/* Rutas protegidas - Envueltas en EmpresasProvider */}
      <Route path="/dashboard" element={
        <PrivateRoute requiredPermissions={['dashboard.ver']}>
          <EmpresasProvider>
            <Layout>
              <DashboardAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Reportes */}
      <Route path="/reportes" element={
        <PrivateRoute requiredPermissions={['reportes.ver']}>
          <EmpresasProvider>
            <Layout>
              <ReportesListAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Análisis Multi-Criterio */}
      <Route path="/analisis" element={
        <PrivateRoute requiredPermissions={['analisis.ejecutar']}>
          <EmpresasProvider>
            <Layout>
              <AnalisisView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      {/* Informe de Avance */}
      <Route path="/informe-avance" element={
        <PrivateRoute requiredPermissions={['analisis.ejecutar']}>
          <EmpresasProvider>
            <Layout>
              <InformeAvanceAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      {/* Gestión */}
      <Route path="/gestion" element={
        <PrivateRoute requiredPermissions={['gestion.ver']}>
          <EmpresasProvider>
            <Layout>
              <GestionAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/gestion/operacion" element={
        <PrivateRoute requiredPermissions={['gestion.ver']}>
          <EmpresasProvider>
            <Layout>
              <OperacionView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/gestion/consumos" element={
        <PrivateRoute requiredPermissions={['gestion.ver']}>
          <EmpresasProvider>
            <Layout>
              <ConsumosView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      {/* Control de Combustible */}
      <Route path="/control-combustible" element={
        <PrivateRoute requiredPermissions={['reportes.ver']}>
          <EmpresasProvider>
            <Layout>
              <ControlCombustibleView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      {/* Órdenes de Carga de Combustible */}
      <Route path="/ordenes-carga-combustible" element={
        <PrivateRoute requiredPermissions={['reportes.ver']}>
          <EmpresasProvider>
            <Layout>
              <OrdenesCargaCombustibleAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/ordenes-carga-combustible/solicitar" element={
        <PrivateRoute requiredPermissions={['reportes.ver']}>
          <EmpresasProvider>
            <Layout>
              <SolicitarCargaMovilView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/ordenes-carga-combustible/:id/cargar/:destinoId" element={
        <PrivateRoute requiredPermissions={['reportes.ver']}>
          <EmpresasProvider>
            <Layout>
              <CargarOrdenMovilView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/reportes/crear" element={
        <PrivateRoute requiredPermissions={['reportes.crear']}>
          <EmpresasProvider>
            <Layout>
              <CrearReporteAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/reportes/:id" element={
        <PrivateRoute requiredPermissions={['reportes.ver']}>
          <EmpresasProvider>
            <Layout>
              <ReporteDetalleAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/reportes/:id/editar" element={
        <PrivateRoute requiredPermissions={['reportes.editar']}>
          <EmpresasProvider>
            <Layout>
              <EditarReporteAutoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Máquinas */}
      <Route path="/admin/maquinas" element={
        <PrivateRoute requiredPermissions={['maquinas.ver']}>
          <EmpresasProvider>
            <Layout>
              <MaquinasView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Administración */}
      <Route path="/admin" element={
        <PrivateRoute>
          <EmpresasProvider>
            <Layout>
              <AdminView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/admin/operadores" element={
        <PrivateRoute requiredPermissions={['operadores.ver']}>
          <EmpresasProvider>
            <Layout>
              <OperadoresView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/admin/faenas" element={
        <PrivateRoute requiredPermissions={['faenas.ver']}>
          <EmpresasProvider>
            <Layout>
              <FaenasView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/admin/calificadores" element={
        <PrivateRoute requiredPermissions={['faenas.ver']}>
          <EmpresasProvider>
            <Layout>
              <CalificadoresView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/admin/predios" element={
        <PrivateRoute requiredPermissions={['predios.ver']}>
          <EmpresasProvider>
            <Layout>
              <PrediosView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/admin/rodales" element={
        <PrivateRoute requiredPermissions={['rodales.ver']}>
          <EmpresasProvider>
            <Layout>
              <RodalesView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/admin/insumos" element={
        <PrivateRoute requiredPermissions={['insumos.ver']}>
          <EmpresasProvider>
            <Layout>
              <InsumosView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      <Route path="/admin/proveedores" element={
        <PrivateRoute requiredPermissions={['proveedores.ver']}>
          <EmpresasProvider>
            <Layout>
              <ProveedoresView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/admin/vehiculos" element={
        <PrivateRoute requiredPermissions={['vehiculos.ver']}>
          <EmpresasProvider>
            <Layout>
              <VehiculosView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/admin/tarjetas" element={
        <PrivateRoute requiredPermissions={['tarjetas.ver']}>
          <EmpresasProvider>
            <Layout>
              <TarjetasView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/admin/emisores" element={
        <PrivateRoute requiredPermissions={['emisores.ver']}>
          <EmpresasProvider>
            <Layout>
              <EmisoresView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      <Route path="/admin/items-chequeo" element={
        <PrivateRoute requiredPermissions={['items_chequeo.ver']}>
          <EmpresasProvider>
            <Layout>
              <ItemsChequeoView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Configuración de controles opcionales por organización */}
      <Route path="/admin/configuracion" element={
        <PrivateRoute requiredPermissions={['sistema.administrar']}>
          <EmpresasProvider>
            <Layout>
              <ConfiguracionEmpresaView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />

      {/* Panel de Administración de Empresas */}
      <Route path="/admin/empresas" element={
        <PrivateRoute requiredPermissions={['empresas.ver']}>
          <EmpresasProvider>
            <Layout>
              <EmpresasAdminView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Control de Usuarios y Máquinas - Solo superusers */}
      <Route path="/admin/usuarios-maquinas" element={
        <PrivateRoute requiredPermissions={['maquinas.administrar']}>
          <EmpresasProvider>
            <Layout>
              <AdminUsuariosMaquinasView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Control de Usuarios y Operadores - Solo superusers */}
      <Route path="/admin/usuarios-operadores" element={
        <PrivateRoute requiredPermissions={['operadores.administrar']}>
          <EmpresasProvider>
            <Layout>
              <AdminUsuariosOperadoresView />
            </Layout>
          </EmpresasProvider>
        </PrivateRoute>
      } />
      
      {/* Ruta raíz - redirige al dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* 404 */}
      <Route path="*" element={
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center py-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
            <p className="text-gray-600">Página no encontrada</p>
          </div>
        </div>
      } />
      </Routes>
    </AuthProvider>
  )
}

export default App
